import React from 'react';
import '../styles/about-us.css';

const aboutData = {
    "title": "Giới thiệu về iampesmobile.com",
    "intro": "iampesmobile.com là website chuyên cung cấp tài khoản game eFootball Mobile, nạp game Mobile, gift card Apple và các dịch vụ tiện ích khác uy tín hàng đầu Việt Nam.",
    "goals": [
        "Xử lý đơn nhanh chóng",
        "Bảo hành minh bạch – Giao dịch rõ ràng",
        "Chất lượng dịch vụ là ưu tiên số một"
    ],
    "reasons": [
        {
            "title": "1. Uy tín đặt lên hàng đầu",
            "points": [
                "Thương hiệu 5 năm trong cộng đồng eFootball",
                "Giao dịch minh bạch, lịch sử rõ ràng",
                "Hàng trăm nghìn khách hàng tin tưởng mỗi tháng",
                "Được đề xuất trong nhiều hội nhóm game thủ tại Việt Nam"
            ]
        },
        {
            "title": "2. Sản phẩm – Dịch vụ đa dạng",
            "points": [
                "Tài khoản: eFootball, CapCut Pro, PUBG, Free Fire, Liên Quân…",
                "Gift card quốc tế: Apple, Google Play, Netflix, Spotify, Steam…",
                "Nạp game Android/iOS giá tốt, quy trình đơn giản",
                "Thuê/mua tài khoản cá nhân hóa theo nhu cầu"
            ]
        },
        {
            "title": "3. Thanh toán nhanh chóng – tiện lợi",
            "points": [
                "Chuyển khoản ngân hàng",
                "Ví điện tử: Momo, ZaloPay, Viettel Money…",
                "Gift code nội bộ / thẻ nạp",
                "Hệ thống tự động xử lý 1–5 phút"
            ]
        },
        {
            "title": "4. Bảo hành rõ ràng – Hỗ trợ liên tục",
            "points": [
                "Bảo hành 100% sản phẩm lỗi",
                "Hỗ trợ qua Zalo, Telegram, Fanpage (cả tuần)",
                "Thời gian phản hồi ~2 phút",
                "TeamView hỗ trợ trực tiếp nếu cần"
            ]
        },
        {
            "title": "5. Giá tốt – Ưu đãi hấp dẫn",
            "points": [
                "Giá cạnh tranh, cập nhật theo thị trường",
                "Ưu đãi định kỳ, flash sale, tích điểm – đổi quà"
            ]
        }
    ],
    "conclusion": "iampesmobile.com không chỉ là nơi bạn mua tài khoản game hay nạp game nhanh chóng – mà là nơi bạn được tư vấn, hỗ trợ và đồng hành trong suốt hành trình giải trí và sáng tạo của mình."
}  

const AboutUs = () => {
    return (
        <div className="about-page-shell">
            <section className="about-page-hero">
                <p className="about-page-kicker">About iampesmobile</p>
                <h1 className="about-page-title">{aboutData.title}</h1>
                <p className="about-page-intro">{aboutData.intro}</p>
            </section>

            <section className="about-page-section">
                <h2 className="about-page-section-title">Mục tiêu hoạt động</h2>
                <div className="about-goal-grid">
                    {aboutData.goals.map((goal, index) => (
                        <article className="about-goal-item" key={index}>
                            <span className="about-goal-index">0{index + 1}</span>
                            <p>{goal}</p>
                        </article>
                    ))}
                </div>
            </section>

            <section className="about-page-section">
                <h2 className="about-page-section-title">Vì sao khách hàng chọn iampesmobile.com?</h2>
                <div className="about-reason-grid">
                    {aboutData.reasons.map((reason, index) => (
                        <article className="about-reason-card" key={index}>
                            <h3 className="about-reason-title">{reason.title}</h3>
                            <ul className="about-reason-list">
                                {reason.points.map((point, i) => (
                                    <li key={i}>{point}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </section>

            <section className="about-page-footer-note">
                <p>{aboutData.conclusion}</p>
            </section>
        </div>
    );
};

export default AboutUs;
